module.exports = __webpack_public_path__ + "static/media/new_list.8add5f92.png";